import { useContext, useEffect, useState } from '@wordpress/element';
import { CampoInput } from '@componentsNew/Input/CampoInput';
import EstruturaPostContext from '@pages/DicasOtimizacao/Context/EstruturaPostContext';

function MetaDescription({ nota, carregando }) {

  return (
    <>
      <CampoInput
        label={'Meta description'}
        multilinhas={true}
        carregando={carregando}
        campoEstrutura={'meta_descricao'}
        nota={nota}
        textarea={true}
      />
    </>
  );
}

export default MetaDescription;
